import SpaceTheme from './space';
import SpidermanTheme from './spiderman';
import UnicornTheme from './unicorn';

export default [UnicornTheme, SpidermanTheme, SpaceTheme];
